import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '../../../../services';
import { ReferralService } from '../../../../services/referral.service';

@Component({
  selector: 'app-referrals',
  templateUrl: './referrals.component.html',
  styleUrls: ['./referrals.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReferralsComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private referralService: ReferralService,
    private helpersService: HelpersService,
  ) {}

  referrals: Referral[] = [];
  statuses: any[] = [];
  referral: Referral = new Referral();
  columns: any[] = [];
  referralsLoaded: boolean = false;
  showReferral: boolean = false;
  public loading: boolean = false;
  public search: boolean = false;
  partner: any = this.helpersService.getPartnerData();

  ngOnInit() {
    this.loading = true;

    this.columns = [
      {
        field: 'Description',
        header: this.translate.instant('bikeshop.referrals.description'),
      },
      {
        field: 'Code',
        header: this.translate.instant('bikeshop.referrals.referral_code'),
      },
      {
        field: 'ReferralRewardAmount',
        header: this.translate.instant(
          'bikeshop.referrals.amount_per_referral',
        ),
      },
      {
        field: 'ReferralMaximumEarnings',
        header: this.translate.instant(
          'bikeshop.referrals.maximum_a_client_can_earn',
        ),
      },
      {
        field: 'ExpiresInMonths',
        header: this.translate.instant('bikeshop.referrals.expires_in'),
      },
      {
        field: 'OnlyIfNewCustomer',
        header: this.translate.instant(
          'bikeshop.referrals.only_if_new_customer',
        ),
      },
      {
        field: 'ApplyOnStatusDescription',
        header: this.translate.instant('bikeshop.referrals.apply_on'),
      },
      {
        field: 'RedeemOnStatusDescription',
        header: this.translate.instant('bikeshop.referrals.redeem_on'),
      },
      {
        field: 'IsActive',
        header: this.translate.instant('bikeshop.referrals.active'),
      },
    ];

    this.referralService.getServiceStatuses().subscribe((statuses) => {
      this.statuses = [];
      statuses.forEach((x) => {
        this.statuses.push({ code: x.ID, name: x.Description });
      });
      this.getReferrals();
    });
  }

  getBooleanValue(val) {
    return val;
  }

  closeReferral() {
    this.showReferral = false;
  }

  getReferrals() {
    this.referralService.getReferrals(this.partner.ID).subscribe((res) => {
      this.loading = false;
      if (res != null) {
        this.referrals = res.Settings;
        this.populateReferralFields();
        this.referralsLoaded = true;
        this.loading = false;
      }
    });
  }

  showReferralItem(item, isNew) {
    if (isNew) this.referral = new Referral();
    else this.referral = item;

    if (this.referral.PartnerID == 0) this.referral.PartnerID = this.partner.ID;

    this.showReferral = true;
  }

  validate() {
    if (this.referral.Description == '') return false;
    if (this.referral.ReferralCodeLength < 10) return false;
    if (this.referral.ReferralCodeLength > 20) return false;
    if (this.referral.ReferralRewardAmount < 1) return false;
    if (this.referral.ExpiresInMonths < 1) return false;
    if (this.referral.ReferralMaximumEarnings < 1) return false;
    if (this.referral.ApplyOn.length == 0) return false;
    if (this.referral.RedeemOn.length == 0) return false;

    return true;
  }

  save() {
    this.referral.RedeemOnStatus = [];
    this.referral.RedeemOn.forEach((x) => {
      this.referral.RedeemOnStatus.push({ ID: x.code });
    });

    this.referral.ApplyOnStatus = [];
    this.referral.ApplyOn.forEach((x) => {
      this.referral.ApplyOnStatus.push({ ID: x.code });
    });

    console.log(this.referral);

    if (this.referral.ID == 0) {
      //save
      this.referralService
        .saveReferral(this.referral, this.partner.ID)
        .subscribe((res) => {
          this.referrals = res.Settings;
          this.getReferrals();
          this.showReferral = false;
        });
    } else {
      //update
      this.referralService
        .updateReferral(this.referral, this.partner.ID)
        .subscribe((res) => {
          var index = this.referrals.findIndex((x) => x.ID == res.ID);
          this.referrals[index] = res;
          this.getReferrals();
          this.showReferral = false;
        });
    }
  }

  populateReferralFields() {
    this.referrals.forEach((x) => {
      x.ApplyOnStatusDescription = '';
      x.RedeemOnStatusDescription = '';
      x.Code =
        x.ReferralPrefix +
        '{{' +
        x.ReferralCodeLength +
        '}}' +
        x.ReferralSuffix;
      x.ApplyOn = [];
      x.ApplyOnStatus.forEach((y) => {
        var lbl = this.statuses.find((z) => z.code == y.ID).name;
        x.ApplyOn.push({ name: lbl, code: y.ID });
        x.ApplyOnStatusDescription += lbl + '; ';
      });
      x.RedeemOn = [];
      x.RedeemOnStatus.forEach((y) => {
        var lbl = this.statuses.find((z) => z.code == y.ID).name;
        x.RedeemOn.push({ name: lbl, code: y.ID });
        x.RedeemOnStatusDescription += lbl + '; ';
      });
    });
  }

  inputChanged() {}
}

export class Referral {
  ApplyOnStatus: Status[] = [{ ID: 50 }];
  ApplyOn: any[] = [];
  ApplyOnStatusDescription: string = '';
  Code: string = '';
  Description: string = '';
  ExpiresInMonths: number = 12;
  ID: number = 0;
  IsActive: boolean;
  IsFixedAmount: boolean = true;
  IsPercentValue: false;
  OnlyIfNewCustomer: boolean;
  PartnerID: number;
  RedeemOnStatus: Status[] = [{ ID: 45 }];
  RedeemOn: any[] = [];
  RedeemOnStatusDescription: string = '';
  ReferralCodeLength: number = 10;
  ReferralMaximumEarnings: number = 100.0;
  ReferralPrefix: string = '';
  ReferralRewardAmount: number = 5.0;
  ReferralSuffix: string = '';
  AlertMessage: string = '';
  AlertMessageDelay: number = 1.0;
  TemplateMessage: string = '';
  TemplateMessageDelay: number = 1.5;
  NotificationMessage: string = '';
  ConfirmationMessage: string = '';
}

export class Status {
    ID: number
}
